import apiCustomerZone from '@/api/customer-zone'
export default [
  {
    path: '/customer-zones',
    name: 'customer-zone',
    meta: { requiresAuth: true },
    component: () => import('@/pages/customer-zone/index.vue')
  },
  {
    path: '/customer-zones/:id',
    name: 'customer-zone-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/customer-zone/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      let response = await apiCustomerZone.find(to.params.id)
      to.params.editData = response.data
      next()
    }
  }
]
